<template>
    <v-row
        v-if="order?.status !== 'IN_PROGRESS'"
        no-gutters
        :class="{'flex-grow-0': !editeReservationStatus}"
        class="align-center"
    >
        <div v-if="!editeReservationStatus">
            <p :class="useStatusColor">
                {{ useOrderStatus }}
                <v-btn
                    v-if="authStore.isTO1"
                    size="small"
                    icon="mdi-pencil"
                    variant="text"
                    color="grey"
                    data-cy="edit"
                    @click="editeReservationStatus = !editeReservationStatus"
                />
            </p>
        </div>
        <order-details-edit-reservation-status
            v-else
            :order-id="order.orderId"
            :status="order.status"
            :loading="reservationStatusLoading"
            max-width="300"
            @save="onChangeReservationStatus"
            @close="editeReservationStatus = false"
        />
    </v-row>
</template>
<script setup lang="ts">
    import OrderDetailsEditReservationStatus from '@/components/account/OrderDetailsEditReservationStatus.vue'

    const editeReservationStatus = ref<boolean>(false)
    const reservationStatusLoading = ref<boolean>(false)

    const app = useNuxtApp()
    const {t} = useI18n()

    const useOrderStatus = computed(() => {
        if (!order.value?.status) return null
        return t(`order_statuses.${order.value.status.toUpperCase().replace(/[\s.]/g, '_')}`)
    })

    const order = computed(() => {
        return runtimeStore.orderDetails
    })

    const useStatusColor = computed(() => {
        return runtimeStore.orderStatusColor(order.value.status)
    })

    const onChangeReservationStatus = async status => {
        reservationStatusLoading.value = true

        try {
            await app.$api.orders.put(order.value.orderId, {status})
            runtimeStore.SET_ORDER_DETAILS({...order.value, status})
            editeReservationStatus.value = false
        } catch (e) {
            app.$toast.error(t('data_update_fail'))
        } finally {
            reservationStatusLoading.value = false
        }
    }
</script>
